import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VCard,{staticClass:"mx-auto mt-5",attrs:{"width":"400"}},[_c(VCardTitle,[_c('h1',{staticClass:"display-1"},[_vm._v("Connexion")])]),(_vm.error)?_c(VCardText,[_c(VAlert,{attrs:{"type":"error"}},[_vm._v(_vm._s(_vm.error))])],1):_c(VCardText,[_vm._v("Connexion en cours")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }